import { Card, CardContent } from "@/components/uiDir/card";
import { Smartphone, QrCode, Palette, BarChart3, Users, Zap, Nfc, Edit } from "lucide-react";
import nfcIcon from "@/assets/nfc-icon.png";
import qrIcon from "@/assets/qr-icon.png";
import customizeIcon from "@/assets/customize-icon.png";

const Features = () => {
  const features = [
    {
      // icon: <img src={nfcIcon} alt="NFC" className="w-12 h-12" />,
      icon: <Nfc className="w-12 h-12 text-primary" />,
      title: "NFC Enabled",
      description: "Tap your student ID to instantly share your portfolio. No apps required.",
    },
    {
      icon: <QrCode className="w-12 h-12 text-secondary" />,
      title: "QR Code Ready",
      description: "Generate a personal QR code for easy sharing on resumes and business cards.",
    },
    {
      icon: <Edit className="w-12 h-12 text-accent" />,
      title: "Fully Customizable",
      description: "Choose from multiple themes and customize colors to match your style.",
    },
    {
      icon: <BarChart3 className="w-12 h-12 text-primary" />,
      title: "Analytics Dashboard",
      description: "Track views, downloads, and engagement with detailed insights.",
    },
    {
      icon: <Users className="w-12 h-12 text-secondary" />,
      title: "Collaboration Tags",
      description: "Tag teammates and showcase collaborative projects with proper credits.",
    },
    {
      icon: <Zap className="w-12 h-12 text-accent" />,
      title: "Fast",
      description: "Optimized for mobile with instant loading times. Your work, always ready.",
    },
  ];

  return (
    <section id="features" className="py-14 sm:py-16 lg:py-20 bg-gradient-subtle">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16 animate-slide-up">
          <h2 className="font-heading text-4xl md:text-5xl font-bold mb-4">
            Everything You Need to{" "}
           <span
            className="glitch-text-number"
            data-text="Showcase Your Work"
          >
            Showcase Your Work
          </span>

          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Built specifically for BMMA, ENTREP, COMSCI, EMC, and InfoSystem students at CIIT
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <Card 
              key={index}
              className="glass-card hover:shadow-lg transition-all duration-300 hover:-translate-y-1 animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CardContent className="p-5 sm:p-6">
                <div className="mb-4 flex justify-center">
                  {feature.icon}
                </div>
                <h3 className="font-heading text-xl font-semibold mb-2 text-center">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground text-center text-sm">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
